import React from 'react'
import PickupClientSection from './../PickupClientSection'
import { FlyerCodesGiveOutWidget } from './../FlyerCodesGiveOutWidget'
import MissionsTable from './../MissionsTable'

const ClientView = props => {
  const {
    availableMerchandise = [],
    givenOutMerchandise = [],
    availableCodes = [],
    givenOutCodes = [],
    ambassadors = [],
    missions = [],
    clientLogo = '',
    clientName = '',
    assignInventoryToUser,
    returnInventoryFromUser,
    filterByCodes,
    filterByMerch,
    updateLocalInventoryState,
  } = props
  return (
    <div>
      <PickupClientSection logo={clientLogo} name={clientName}>
        <h4 className="section-title">Merchandise</h4>
        <FlyerCodesGiveOutWidget
          inventoryType="Merchandise"
          updateLocalInventoryState={updateLocalInventoryState}
          availableCodes={(() => {
            if (!filterByMerch) return availableMerchandise
            var filterHash = {}
            filterByMerch.forEach(c => (filterHash[c] = true))
            return availableMerchandise.filter(c =>
              filterByMerch.includes(`${c.title} ${c.code}`),
            )
          })()}
          givenOutCodes={(() => {
            if (!filterByMerch) return givenOutMerchandise
            var filterHash = {}
            filterByMerch.forEach(c => (filterHash[c] = true))
            return givenOutMerchandise.filter(c =>
              filterByMerch.includes(`${c.title} ${c.code}`),
            )
          })()}
          onGiveInventoryToBA={function(ambassadorId, inventoryObj) {
            return assignInventoryToUser(inventoryObj, 1, ambassadorId)
          }}
          onReturnCode={function(ambassadorId, inventoryObj) {
            return returnInventoryFromUser(inventoryObj, 1, ambassadorId)
          }}
          ambassadors={ambassadors}
        />
        <h4 className="section-title">Missions</h4>
        <MissionsTable missions={missions} />
        <h4 className="section-title">Flyers</h4>
        <FlyerCodesGiveOutWidget
          inventoryType="Flyers"
          updateLocalInventoryState={updateLocalInventoryState}
          totalAvailableCodes={availableCodes.length}
          availableCodes={(() => {
            if (filterByCodes === null || filterByCodes.length === 0)
              return availableCodes
            var filterHash = {}
            filterByCodes.forEach(c => (filterHash[c] = true))
            return availableCodes.filter(c => filterHash[c.code])
          })()}
          givenOutCodes={(() => {
            if (filterByCodes === null || filterByCodes.length === 0)
              return givenOutCodes
            var filterHash = {}
            filterByCodes.forEach(c => (filterHash[c] = true))
            return givenOutCodes.filter(c => filterHash[c.code])
          })()}
          onGiveInventoryToBA={function(ambassadorId, inventoryObj) {
            return assignInventoryToUser(
              inventoryObj,
              inventoryObj.quantity,
              ambassadorId,
            )
          }}
          onReturnCode={function(ambassadorId, inventoryObj) {
            return returnInventoryFromUser(
              inventoryObj,
              inventoryObj.quantity,
              ambassadorId,
            )
          }}
          ambassadors={ambassadors}
        />
      </PickupClientSection>
    </div>
  )
}

export default ClientView



// WEBPACK FOOTER //
// ./src/Containers/Form/City/Pickup/new/ClientView.js